


















































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  GetShezhenjiaocai$,
  GetDianxingshetu$,
} from "@/request/shezhenjiaoxue";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import LeftNav from "../../components/left-nav.vue";
import PhotoPreview from "@/components/pic-preview.vue";
import catalogData from "./catalog";
import DingxingCatalogData from "../dxst/catalog";
@Component({
  components: {
    MainHeader,
    LeftNav,
    PhotoPreview,
  },
})
export default class SzjxSzjc extends Vue {
  private catalogData: any[] = catalogData["人民卫生出版社"];
  private publisher: any = "";
  private title1: any = "";
  private title2: any = "";
  private title3: any = "";
  private result: any = {};
  private ifShowCatalog: boolean = true;
  private ifShowPhotoPreview: boolean = false;
  private tempUrl: any = "";
  private ifShowHelp: boolean = false;
  private model: any = {};
  @Watch("$route.query", { immediate: true, deep: true })
  private queryChange(query) {
    this.catalogData = catalogData[query["publisher"]];
    this.publisher = query.publisher;
    this.title1 = query["title1"];
    this.title2 = query["title2"];
    this.title3 = query["title3"];
    this.fetchContent(this.title1, this.title2, this.title3);
  }

  /**
   *
   * @description 开关目录条
   */
  private triggerCatalog() {
    this.ifShowCatalog = !this.ifShowCatalog;
  }
  /**
   * @description 展示第二层
   */
  private showSecond(index, ifShow) {
    this.catalogData[index]["ifShowSecond"] = ifShow;
  }
  /**
   * @description 展示第三层
   */
  private showThird(index, fIndex, ifShow) {
    this.catalogData[fIndex]["children"][index]["ifShowThird"] = ifShow;
  }
  /**
   * @description 获取内容
   */
  private fetchContent(title1, title2?, title3?) {
    const publisher = this.publisher.replace(/[舌面]诊部分$/g, "");
    const parmas: any = {
      publisher,
      title1,
      title2,
      title3,
    };
    GetShezhenjiaocai$(this, parmas).then((data: any) => {
      // console.log(data);
      this.result = data;
    });
  }
  /**
   * @description 点击第一层
   */
  private triggerFirst(first, firstIndex) {
    if (first.children && first.children.length > 0) {
      this.showSecond(
        firstIndex,
        !this.catalogData[firstIndex]["ifShowSecond"]
      );
      if (first.ifHasContent) {
        this.fetchContent(first["name"]);
      }
    } else {
      this.fetchContent(first["name"]);
    }
  }
  /**
   * @description 点击第二层
   */
  private triggetSecond(second, secondIndex, firstIndex) {
    if (second.children && second.children.length > 0) {
      this.showThird(
        secondIndex,
        firstIndex,
        !this.catalogData[firstIndex]["children"][secondIndex]["ifShowThird"]
      );
      if (second.ifHasContent) {
        this.fetchContent(this.catalogData[firstIndex]["name"], second["name"]);
      }
    } else {
      this.fetchContent(this.catalogData[firstIndex]["name"], second["name"]);
    }
  }
  /**
   * @description 预览图片
   */
  private showPhotoPreview(url) {
    this.ifShowHelp = false;
    this.tempUrl = url;
    this.ifShowPhotoPreview = true;
  }
  /**
   * @description 展示右侧弹窗
   */
  private showHelp(item) {
    const params: any = {};
    DingxingCatalogData.forEach((first: any) => {
      first["children"].forEach((second: any) => {
        second["children"].forEach((third: any) => {
          if (third["name"] === item["name"]) {
            params["title1"] = first["name"];
            params["title2"] = second["name"];
            params["title3"] = third["name"];
          }
        });
      });
    });
    GetDianxingshetu$(this, params).then((data: any) => {
      console.log(data);
      this.model = data;
      this.ifShowHelp = true;
    });
  }
}
